import { createClient } from "@supabase/supabase-js";

// A chave publishable é pública por desenho — ela vai dentro do bundle que qualquer
// visitante baixa. O que protege os dados são as políticas de RLS no banco, não esta
// chave. Nunca coloque aqui a chave secreta (sb_secret_… / service_role).
//
// Os valores abaixo são o padrão. Para trocar de projeto sem mexer no código, defina
// REACT_APP_SUPABASE_URL e REACT_APP_SUPABASE_KEY nas variáveis de ambiente do Vercel.
const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || "https://yuanygmnxkhyncajmlys.supabase.co";
const SUPABASE_KEY =
  process.env.REACT_APP_SUPABASE_KEY ||
  "sb_publishable_chxPEfWffSsmOMPE9Ss4rw_DVkhzOpk";

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    persistSession: true,      // mantém o login entre visitas (substitui o antigo "lembrar acesso")
    autoRefreshToken: true,
    detectSessionInUrl: true   // necessário para o link de recuperação de senha voltar ao app
  }
});

// Mensagens do Supabase vêm em inglês. Traduz as que o usuário realmente vê.
export function traduzErro(msg) {
  const m = String(msg || "").toLowerCase();
  if (m.includes("invalid login credentials")) return "Email ou senha incorretos.";
  if (m.includes("email not confirmed")) return "Confirme seu email antes de entrar.";
  if (m.includes("user already registered") || m.includes("already been registered"))
    return "Este email já está cadastrado.";
  if (m.includes("password should be at least"))
    return "A senha deve ter no mínimo 6 caracteres.";
  if (m.includes("unable to validate email") || m.includes("invalid email"))
    return "Email inválido.";
  if (m.includes("email rate limit") || m.includes("too many requests"))
    return "Muitas tentativas. Aguarde alguns minutos e tente novamente.";
  if (m.includes("failed to fetch") || m.includes("networkerror"))
    return "Sem conexão com o servidor. Verifique sua internet.";
  if (m.includes("new password should be different"))
    return "A nova senha deve ser diferente da atual.";
  return msg || "Ocorreu um erro inesperado.";
}
